import React from 'react'
import PropTypes from 'prop-types'
import {
  View,
} from 'react-native'
import {
  VFText,
  Icon,
  VFButton,
} from '@vfgroup-oneplatform/foundation/Components'
import VfText from '../VfText'

import styles from './Bundle.Styles'


const characteristicLabel = {
  uploadspeed: 'bundle_characteristic_upload_label',
  fup: 'bundle_characteristic_fup_label',
  downloadspeed: 'bundle_characteristic_download_label'
}

function Bundle({
  offer,
  onButtonPress,
  showButton,
  buttonTitle,
  iconTypes,
  isLoading = false,
  theme,
  disabled,
  isTV,
}) {


  const renderButton = () => {
    if (!showButton) { return null }
    return (
      <View style={styles.offerBtnContainer(theme)}>
        <VFButton
          type={'primary'}
          title={buttonTitle}
          style={styles.btnStyle}
          disabled={isLoading || disabled}
          onPress={() => onButtonPress(offer)}
        />
      </View>)
  }


  return (
    <View style={styles.itemContentContainer(theme)}>
      <View style={styles.rowContainer}>
        {offer?.content?.map(item => {
          return (
            <View style={styles.rowItem} >
              <Icon
                name={item.icon || (isTV ? iconTypes?.['tv'] : iconTypes?.[item.type])}
                type="image"
                size={25}
                resizeMode="contain"
              />
              <VfText
                i18nKey={isTV ? item : characteristicLabel?.[item.type]}
                style={styles.itemRowTitle}
                isLoading={isLoading}
                placeHolders={[item.title]}
                color={theme.colors.textColor}
              />
            </View>
          )
        })}
        <View style={styles.rowItem} >
          <Icon
            name={iconTypes?.['document']}
            type="image"
            size={25}
            resizeMode="contain"
          />
          <VfText
            i18nKey='bundle_characteristic_document_label'
            style={styles.itemRowTitle}
            isLoading={isLoading}
            color={theme.colors.textColor}
          />
        </View>
      </View>
      {/* {offer?.extraContent && <View style={styles.offerBottomContent}>
        <VfText
          i18nKey={offer?.extraContent?.title ?? ''}
          style={styles.descOfferStyle}
          isLoading={isLoading}

        />
        <View style={styles.offerIconsContainer}>
          {offer?.extraContent?.products?.map(el =>
            <Icon
              name={el.product}
              type="image"
              size={45}
              resizeMode="contain"
              style={styles.itemIcon}
            />
          )}
        </View>
      </View>} */}
      {renderButton()}
    </View>
  )
}

Bundle.propTypes = {
  offer: PropTypes.object,
  onButtonPress: PropTypes.func,
  buttonTitle: PropTypes.string,
  showButton: PropTypes.bool,
  theme: PropTypes.object,
  disabled: PropTypes.bool,
}

Bundle.defaultProps = {
  showHeader: false,
  showButton: true,
  disabled: false
}

export default Bundle
